import {
	Destination,
	StonalEnv,
} from '@local_types/index';
import {
	RudderAnalytics,
} from '@rudderstack/analytics-js';
import {
	buildUrl,
} from '@stonal-tech/lib-front-utils-ts';
import {
	RUDDERSTACK_QUEUE_OPTIONS,
} from '../config/rudderstack';
import {
	URL_PATTERNS,
} from '../config/urlPatterns';

export class RudderStackDestination implements Destination {
	name: string = 'rudderstack';
	offlineResilient: boolean = true;
	rudderSourceID: string;
	rudder: RudderAnalytics | undefined;

	constructor(env: StonalEnv) {
		// If we are in prod, we change the source ID
		this.rudder = undefined;
		this.rudderSourceID = env === 'prod' ? '2VGGWzKDDqUE23ygNTOGrjNqYBP' : '2W5NHgy6vV41gEk5Te9wWPqgm2f';
		this.init = this.init.bind(this);
		this.init();
	}

	init() {
		const rudder = new RudderAnalytics();
		rudder.load(this.rudderSourceID, buildUrl(URL_PATTERNS.RUDDER_DATAPLANE), {
			configUrl: buildUrl(URL_PATTERNS.RUDDER_CONFIG),
			destSDKBaseURL: buildUrl(URL_PATTERNS.RUDDER_SDK_BASE),
			pluginsSDKBaseURL: buildUrl(URL_PATTERNS.RUDDER_PLUGINS_SDK),
			queueOptions: RUDDERSTACK_QUEUE_OPTIONS,
		});
		this.rudder = rudder;
	}

	page(name: string, properties: Record<string, any>) {
		this.rudder?.page(name, properties);
	}

	identify(userId: string | undefined, traits: Record<string, any>) {
		// Don't send empty/invalid userId - let PostHog handle anonymous users properly
		if (!userId) {
			return;
		}
		this.rudder?.identify(userId, traits);
	}


	group(groupId: string, traits?: Record<string, any>) {
		// Associates the current user with a group (organization/company)
		this.rudder?.group(groupId, traits);
	}

	track(event: string, properties: Record<string, any>) {
		this.rudder?.track(event, properties);
	}
}
